var plugin_rtlignore_default = {
  "alignLeft": "qrE5m",
  "textWrapNowrap": "akZUS",
  "alignRight": "tdEJW",
  "alignCenter": "PwKkY",
  "sizeFullWidth": "z80ay",
  "renderedInTable": "U5KP9",
  "sizeOriginal": "e82xJ",
  "sizeContent": "_3hUq7",
  "sizeSmall": "Aa-Hu",
  "sizeSmallCenter": "G01Mn",
  "flex": "_-0-Xy",
  "atomic": "VSd-n",
  "anchor": "DFQK-",
  "embed": "QXwZd",
  "horizontalScrollbar": "FrXlE",
  "pluginContainerMobile": "YesvW"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
